import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { BaseUrlHelperService } from "../helper/baseUrlHelper.service";
import { NbcLoggerService } from "../logger/nbc-logger.service";


@Injectable({
  providedIn: 'root'
})
export class AuthorizationService {
  constructor(private http: HttpClient,
    private _apiroot: BaseUrlHelperService,
    private log: NbcLoggerService) { }

  getBUAccess(buId): Observable<any> {
    this.log.trace("talentPayrollAuthorization: get BU access for logged in user");
    return this.http.get(this._apiroot.baseUrl + "talentPayroll/authorization/getBuaccess/" + buId).pipe(
      catchError((err) => {
        return throwError(err);
      })
    );
  };

  getUserPermissions(buId): Observable<any> {
    this.log.trace("talentPayrollAuthorization: get permissons for logged in user");
    return this.http.post(this._apiroot.baseUrl + "talentPayroll/authorization/getTalentUserPermissions/" + buId, {}).pipe(
      catchError((err) => {
        return throwError(err);
      })
    );
  };
}
